module.exports = __webpack_public_path__ + "img/shangwuhezuo_en_US.08c0e902.png";